import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { I360Service } from 'src/Services/i360Service';
import { CheckAuth } from 'src/Services/utility.service';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { StateCommissionModel } from 'src/Models/stateCommissionModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-front-state-commission',
  templateUrl: './front-state-commission.component.html',
  styleUrls: ['./front-state-commission.component.css']
})
export class FrontStateCommissionComponent implements OnInit {
  tokenKey: string = '';
  loginUser: number = 0;
  listOfState: StateCommissionModel[];

  constructor(private readonly i360Service: I360Service, 
    private readonly titleService: Title, 
    private readonly checkAuth: CheckAuth,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) { }

    ngOnInit() {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.loginUser = +sessionStorage.getItem('UserId');
    this.titleService.setTitle('State Commission | JSi360');
    this.GetStateCommissionWebSites();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetStateCommissionWebSites() {
    this.i360Service.i360StateCommissionWebSitesForFront(this.tokenKey).subscribe(
      data => {
        if (data != null) {
          this.listOfState = data['listOfData'];
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  applicationActivity(actionName, pageName, datatype = 0, actionUrl = '', dataId = 0) {
    ApplicationActivityStore(actionName, pageName, this.appActivity, dataId, datatype, actionUrl)
  }

}
